export default __webpack_public_path__ + "static/media/downloadourappimage2.638bf6ff.png";